module.exports = __webpack_public_path__ + "img/Democratic Republic of Congo.2083247f.svg";